import { Steps } from 'antd';
import { ButtonType, HtmlType, Space } from 'farmhub-ui-core';

import { CButton } from 'components';
import { GlobalStyle } from 'styled';

import { ContentStep, TextStep, Wrapper } from '../styles';

interface CollaboratorCreatePageContentDesktopProps {
  handleSubmitStep: (e: number) => void;
  handleNextStep: () => any;
  ListStep: any[];
  isSubmitting: boolean;
  currentTab: number;
  handleChangeCurrentStep: (e: number) => void;
}

const { Step } = Steps;

const CollaboratorCreatePageContentDesktop = ({
  handleSubmitStep,
  handleNextStep,
  ListStep,
  isSubmitting,
  currentTab,
  handleChangeCurrentStep,
}: CollaboratorCreatePageContentDesktopProps): JSX.Element => (
  <Wrapper>
    <Steps
      current={currentTab}
      labelPlacement="vertical"
      style={{ width: 600 }}
    >
      <Step
        style={{ cursor: 'pointer' }}
        title="Thông tin"
        onClick={() => handleChangeCurrentStep(0)}
      />
      <Step
        style={{ cursor: 'pointer' }}
        title="Liên kết đối tác"
        onClick={() => handleSubmitStep(1)}
      />
      <Step
        style={{ cursor: 'pointer' }}
        title="Sản phẩm"
        onClick={() => handleSubmitStep(2)}
      />
      {ListStep.length === 4 && (
        <Step
          style={{ cursor: 'pointer' }}
          title="Chính sách giá"
          onClick={() => handleSubmitStep(3)}
        />
      )}
    </Steps>
    <Space height={24} />
    <ContentStep>
      {ListStep[currentTab]}
      <CButton
        htmlType={HtmlType.Submit}
        loading={isSubmitting}
        type={ButtonType.Primary}
        width="420px"
        onClick={handleNextStep}
      >
        Xác nhận
      </CButton>
      <div id="recaptcha-container" />
    </ContentStep>
    <GlobalStyle />
  </Wrapper>
);

export default CollaboratorCreatePageContentDesktop;
